import { isNumber } from '@beautybox/core/utils';
import { Api } from '@beautybox/core/api';

/** Инициализация модуля запросов */
let provider;
export function init(config) {
    provider = new Api(config.BASE_URL, 'link', config.token, false);
}

/** Начальное состояние */
const state = () => ({
    address: {
        name: '',
        description: '',
    },
    addresses: [],
    countAddresses: 0,
    loading: false,
    userRole: '',
    profile: {},
});

const mutations = {
    ADDRESS_SUCCESS(state, payload) {
        state.addresses = payload;
        console.log('--- ADDRESS_SUCCESS', state.addresses);
    },
    COUNT_ADDRESSES_SUCCESS(state, payload) {
        state.countAddresses = payload;
        console.log('--- COUNT_ADDRESSES_SUCCESS', state.countAddresses);
    },
    USER_ROLE_SUCCESS(state, payload) {
        state.userRole = payload;
        console.log('--- USER_ROLE_SUCCESS', state.userRole);
    },
    SET_PROFILE(state, profile) {
        state.profile = { ...profile };
    },
};

const actions = {
    async GET_PROFILE({ commit }, { id }) {
        const { errors = {}, ...profile } = await provider.get(`/${id}/info`);
        if (!Object.keys(errors).length) {
            commit('SET_PROFILE', profile);
        }
    },
    async GET_ADDRESS({ commit }, { id }) {
        console.log('--- GET_ADDRESSES', id);
        console.log('--- GET_ADDRESSES', await provider.get(`/${id}/addresses`));
        const { errors = {}, addresses = [] } = await provider.get(`/${id}/addresses`);

        if (!Object.keys(errors).length) {
            commit('ADDRESS_SUCCESS', addresses);
        }
    },
    async GET_COUNT_ADDRESSES({ commit }, { id }) {
        const { errors = {}, countAddresses = 1 } = await provider.get(`/${id}/addresses/count`);

        if (!Object.keys(errors).length) {
            commit('COUNT_ADDRESSES_SUCCESS', countAddresses);
        }
    },
    SET_USER_ROLE({ commit }, role) {
        console.log('--- SET_USER_ROLE', role);
        commit('USER_ROLE_SUCCESS', role);
    },
};

const getters = {
    ADDRESS: (state) => (id) => {
        return state.addresses.find((item) => {
            if (isNumber(id)) {
                return item.addressID === parseInt(id);
            } else {
                return item.nickname.toLowerCase() === id.toLowerCase();
            }
        });
    },
    COUNT_ADDRESSES: (state) => state.countAddresses,
    LOADING: (state) => state.loading,
    USER_ROLE: (state) => state.userRole,
    SALON_PROFILE: (state) => state.profile,
};

export default { state, mutations, actions, getters, init };
